import z from "zod";

import { dateSchema } from "./utils";

const liveContentSchema = z.object({
  channel_id: z.coerce.string(),
  name: z.string(),
  image_url: z.string(),
  redirect_url: z.string(),
  program: z.object({
    title: z.string(),
    description: z.string(),
    start_time: dateSchema,
    end_time: dateSchema,
  }),
});

type LiveContent = z.infer<typeof liveContentSchema>;

export { liveContentSchema, type LiveContent };
